import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import { IonLabel, IonList, IonItem, IonContent } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionsModal',
  setup(__props) {

const options = [
  { label: 'Report a typo', action: 'report-typo' },
  { label: 'Report a factual', action: 'report-factual' },
  { label: 'Ask a question', action: 'ask-question' },
  { label: 'Suggest and edit', action: 'suggest-edit' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonList), null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option, index) => {
            return _createVNode(_unref(IonItem), {
              key: `option-${index}`,
              detail: true,
              button: "",
              onClick: option.action
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})